import { createContext, useContext } from 'react'
import type { FeatureMeta } from '../api'

export type PluginMeta = FeatureMeta & { selfManageChrome: boolean }

const PluginMetaContext = createContext<PluginMeta | null>(null)

export const PluginMetaProvider = PluginMetaContext.Provider

export function usePluginMeta(): PluginMeta {
  const v = useContext(PluginMetaContext)
  if (!v) {
    throw new Error('usePluginMeta must be used inside <PluginHost>')
  }
  return v
}